import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'; // Используйте Link
import '../styles/Cars.css';
import {Helmet} from "react-helmet";

const Cars = () => {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await axios.get('/api/cars/');
        setCars(response.data);
      } catch (err) {
        console.error('Ошибка:', err);
      }
    };

    fetchCars();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Каталог автомобилей для аренды в Калининграде | Выгодные цены на прокат авто</title>
        <meta name="description" content="Выберите авто из нашего каталога: эконом, премиум, внедорожники, микроавтобусы.
         Аренда авто в Калининграде с суточной оплатой. Новые модели, страховка, техподдержка 24/7." />
      </Helmet>
      <h1>Каталог автомобилей</h1>
      <div className="cars-list">
        {cars.map(car => (
          <div key={car.id} className="car-card">
            <h3>{car.brand} {car.model}</h3>
            <img src={car.image} alt={car.model} />
            <p>Цена: {car.price_per_day} руб./сутки</p>
            <p style={{ color: '#9500d8', fontWeight: 'bold' }}>
                Со скидкой: {Math.floor(car.price_per_day * 0.9)} руб./сутки
            </p>
            <Link
              to={`/cars/${car.id}`}
              className="btn btn-primary"
            >
              Подробнее
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cars;